import styled from 'styled-components';

import { COLOR_WHITE } from '@common/assets/styles/colors';

type TAvatarSC = {
  size?: number;
};
export const AvatarSC = styled.div<TAvatarSC>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 50%;
  width: 100%;
  height: 100%;

  img.profile-image {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    width: 100%;
    height: auto;
    background: ${COLOR_WHITE};
  }

  //.avatar-notifications {
  //  position: absolute;
  //  bottom: 0;
  //  right: 0;
  //}

  img.avatar-check {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 40%;
    height: 40%;
  }
`;
